// extracted by mini-css-extract-plugin
export default {"wrapper":"MdtcJ","content-min-tablet":"kuk1O"};